import { useEffect, useRef } from "react";
import "./SplashScreen.css";

const SplashScreen = ({ onComplete }) => {
  const videoRef = useRef(null);
  const finishedRef = useRef(false);

  const finish = () => {
    if (finishedRef.current) return;
    finishedRef.current = true;
    onComplete();
  };

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    let cancelled = false;

    const playMuted = async () => {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute("muted", "");
      video.volume = 1;
      await video.play();
    };

    const start = async () => {
      video.volume = 1;
      try {
        await playMuted();
      } catch {
        // The muted autoplay attribute can still start playback.
      }
      if (cancelled || video.paused) return;

      video.muted = false;
      video.defaultMuted = false;
      video.removeAttribute("muted");
      try {
        await video.play();
        if (!video.paused && !video.muted) return;
      } catch {
        // This browser will not start audio until the visitor interacts.
      }
      if (cancelled || !video.paused) return;
      try {
        await playMuted();
      } catch {
        // Keep the attempt above from leaving the intro stuck.
      }
    };

    const unmute = () => {
      video.muted = false;
      video.defaultMuted = false;
      video.removeAttribute("muted");
      video.volume = 1;
      video.play().catch(() => {});
    };

    start();
    window.addEventListener("pointerdown", unmute);
    window.addEventListener("keydown", unmute);

    return () => {
      cancelled = true;
      window.removeEventListener("pointerdown", unmute);
      window.removeEventListener("keydown", unmute);
    };
  }, []);

  return (
    <div className="splash-screen" role="dialog" aria-label="Star Gate intro">
      <video
        ref={videoRef}
        className="splash-video"
        src="/splash.mp4"
        autoPlay
        muted
        playsInline
        preload="auto"
        onEnded={finish}
        onError={finish}
      />
    </div>
  );
};

export default SplashScreen;
